import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {mapSummaryPageData} from '../mappers'
import {SummaryPageData, SummaryPageDataDto, SummaryPageDataSearchCriteria} from '../types'

export const ShiftSummaryQueryKey = 'shifthandover-summary'

type UseShiftSummaryParams = {
  plantId: string
  timezone: string
  timeRange: {startDate?: Iso8601; endDate?: Iso8601}
  options?: Omit<UseQueryOptions<SummaryPageData, AxiosError>, 'queryKey'>
}

export const useShiftSummary = ({plantId, timezone, timeRange, options}: UseShiftSummaryParams) => {
  const path = `/shifthandover/${plantId}/shiftsummary`

  return useQuery<SummaryPageData, AxiosError>({
    queryKey: [ShiftSummaryQueryKey, timezone, timeRange, plantId],
    queryFn: async ({signal}) => {
      if (!timeRange.startDate || !timeRange.endDate) {
        throw new Error('Invalid time range: startDate or endDate missing')
      }
      const settings: SummaryPageDataSearchCriteria = {
        startDate: timeRange.startDate,
        endDate: timeRange.endDate
      }
      const {data} = await ApiClient.axiosInstance.post<SummaryPageDataDto>(path, settings, {
        signal
      })

      return mapSummaryPageData(data, timezone)
    },
    ...options
  })
}
